module.exports = "https://web-assets.ifttt.com/packs/media/plan-badges/free-cfeb666a.svg";